export default __webpack_public_path__ + "static/media/logo.815d07a4.png";